import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiVehicleShareService } from '../../../../../core/services/api/Vehicle/api-vehicle-share';
import { ApiVehicleService } from '../../../../../core/services/api/Vehicle/api-vehicle';
import { PssWarnComponent } from '../../../../../tools/template/pss/pss-warn/pss-warn.component';
import {
  ShareVehicleInviteResponse,
  ShareVehicleMemberResponse,
  vehicleShareResponse,
} from '../../../../../core/models/member.model';
import { MyVehicleResponse } from '../../../../../core/models/information.model';

@Component({
  selector: 'app-vehicle-share',
  imports: [CommonModule, FormsModule, PssWarnComponent],
  templateUrl: './vehicle-share.component.html',
  styleUrl: './vehicle-share.component.css',
})
export class VehicleShareComponent implements OnInit {
  currentLanguage: 'TH' | 'EN' = 'TH';
  uid = '';
  vehicleShare: vehicleShareResponse[] = [];
  filteredVehicleShare: vehicleShareResponse[] | null = null;
  valueFilterVehicleShare = '';

  modalManage = false;
  selectedGroup: vehicleShareResponse | null = null;
  members: ShareVehicleMemberResponse[] = [];
  pendingInvites: ShareVehicleInviteResponse[] = [];

  modalInvite = false;
  myVehicles: MyVehicleResponse[] = [];
  inviteVehicleId = 0;
  invitePhone = '';
  
  vehicleSearchText = '';
  activeVehicleDropdown = false;

  showConfirmDissolve = false;
  showConfirmRevoke = false;
  revokeTarget: ShareVehicleMemberResponse | null = null;
  pendingInboxCount = 0;

  constructor(
    private router: Router,
    private languageService: LanguageService,
    private toastCustomService: ToastCustomService,
    private apiVehicleShareService: ApiVehicleShareService,
    private apiVehicleService: ApiVehicleService,
    private cookieService: CookieService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLanguage = lang;
    });
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
  }

  ngOnInit() {
    this.loadGroups();
    this.loadInboxCount();
  }

  goback() {
    this.router.navigate(['/home']);
  }

  goInbox() {
    this.router.navigate(['/vehicle-share-inbox']);
  }

  msg(th: string, en: string) {
    return this.currentLanguage === 'TH' ? th : en;
  }

  showWarning(text: string) {
    this.toastCustomService.showWarning('', text);
  }
  showError(text: string) {
    this.toastCustomService.showError('', text);
  }
  showSuccess(text: string) {
    this.toastCustomService.showSuccess('', text);
  }

  onFilterVehicleShare(value: string) {
    if (!value) {
      this.filteredVehicleShare = null;
      return;
    }
    this.filteredVehicleShare = this.vehicleShare.filter((v) =>
      (v.plateNumber || '').toLowerCase().includes(value.toLowerCase())
    );
  }

  loadGroups() {
    this.apiVehicleShareService.getVehicleShare(this.uid).subscribe({
      next: (res) => {
        this.vehicleShare = res || [];
        this.filteredVehicleShare = null;
      },
      error: () => {
        this.vehicleShare = [];
        this.showWarning(this.msg('โหลดรายการไม่สำเร็จ', 'Failed to load list'));
      },
    });
  }

  loadInboxCount() {
    this.apiVehicleShareService.getInvitesInbox(this.uid, 'pending').subscribe({
      next: (res) => {
        this.pendingInboxCount = res?.length || 0;
      },
      error: () => {
        this.pendingInboxCount = 0;
      },
    });
  }

  openManage(group: vehicleShareResponse) {
    this.selectedGroup = group;
    this.modalManage = true;
    this.loadMembers(group.id);
    this.loadPendingForVehicle(group.vehicleId);
  }

  closeManage() {
    this.modalManage = false;
    this.selectedGroup = null;
    this.members = [];
    this.pendingInvites = [];
  }

  loadMembers(groupId: number) {
    this.apiVehicleShareService.getVehicleShareDetails(this.uid, groupId).subscribe({
      next: (res) => {
        this.members = (res || []).filter((m) => !m.disable);
      },
      error: () => {
        this.members = [];
      },
    });
  }

  loadPendingForVehicle(vehicleId: number) {
    this.apiVehicleShareService.getInvitesSent(this.uid, 'pending').subscribe({
      next: (res) => {
        this.pendingInvites = (res || []).filter((i) => i.vehicleId === vehicleId);
      },
      error: () => {
        this.pendingInvites = [];
      },
    });
  }

  get filteredVehicleOptions() {
    const text = this.vehicleSearchText.trim().toLowerCase();
    if (!text) return this.myVehicles;
    return this.myVehicles.filter(v => this.vehicleLabel(v).toLowerCase().includes(text));
  }

  openVehicleDropdown() {
    this.activeVehicleDropdown = true;
  }

  closeVehicleDropdown() {
    setTimeout(() => {
      this.activeVehicleDropdown = false;
      const match = this.myVehicles.find(v => this.vehicleLabel(v) === this.vehicleSearchText);
      if (match) {
        this.inviteVehicleId = match.id;
      } else {
        const current = this.myVehicles.find(v => v.id === this.inviteVehicleId);
        this.vehicleSearchText = current ? this.vehicleLabel(current) : '';
      }
    }, 200);
  }

  selectVehicleOption(v: MyVehicleResponse) {
    this.inviteVehicleId = v.id;
    this.vehicleSearchText = this.vehicleLabel(v);
    this.activeVehicleDropdown = false;
  }

  onPhoneInput(event: any) {
    const val = event.target.value.replace(/[^0-9]/g, '');
    this.invitePhone = val;
    event.target.value = val;
  }

  openInvite(group?: vehicleShareResponse) {
    this.invitePhone = '';
    this.inviteVehicleId = group?.vehicleId || 0;
    this.modalInvite = true;
    this.vehicleSearchText = '';
    this.apiVehicleService.getMyVehicle('', this.uid).subscribe({
      next: (res) => {
        this.myVehicles = res || [];
        if (!this.inviteVehicleId && this.myVehicles.length > 0) {
          this.inviteVehicleId = this.myVehicles[0].id;
        }
        const current = this.myVehicles.find(v => v.id === this.inviteVehicleId);
        this.vehicleSearchText = current ? this.vehicleLabel(current) : '';
      },
      error: () => {
        this.myVehicles = [];
      },
    });
  }

  closeInvite() {
    this.modalInvite = false;
    this.vehicleSearchText = '';
  }

  sendInvite() {
    if (!this.inviteVehicleId) {
      this.showWarning(this.msg('กรุณาเลือกทะเบียนรถ', 'Please select a vehicle'));
      return;
    }
    if (!this.invitePhone.trim()) {
      this.showWarning(this.msg('กรุณากรอกเบอร์โทรผู้รับ', 'Please enter invitee phone'));
      return;
    }

    this.apiVehicleShareService
      .inviteShareVehicle({
        uid: this.uid,
        vehicleId: this.inviteVehicleId,
        toPhone: this.invitePhone.trim(),
      })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || this.msg('ส่งคำเชิญสำเร็จ', 'Invite sent'));
            this.closeInvite();
            this.loadGroups();
            if (this.selectedGroup) {
              this.loadPendingForVehicle(this.selectedGroup.vehicleId);
            }
          } else {
            this.showError(
              this.currentLanguage === 'TH'
                ? res?.message || 'ส่งไม่สำเร็จ'
                : res?.message_en || res?.message || 'Failed'
            );
          }
        },
        error: () => {
          this.showError(this.msg('ส่งไม่สำเร็จ', 'Failed'));
        },
      });
  }

  askRevoke(member: ShareVehicleMemberResponse) {
    this.revokeTarget = member;
    this.showConfirmRevoke = true;
  }

  confirmRevoke() {
    if (!this.selectedGroup || !this.revokeTarget) {
      return;
    }
    const groupId = this.selectedGroup.id;
    const cpUserId = this.revokeTarget.cpUserId;
    this.showConfirmRevoke = false;
    this.apiVehicleShareService
      .revokeMember({ uid: this.uid, groupId, cpUserId })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || this.msg('ถอนสิทธิ์สำเร็จ', 'Revoked'));
            this.loadMembers(groupId);
            this.loadGroups();
          } else {
            this.showError(
              this.currentLanguage === 'TH'
                ? res?.message || 'ไม่สำเร็จ'
                : res?.message_en || 'Failed'
            );
          }
        },
        error: () => this.showError(this.msg('ไม่สำเร็จ', 'Failed')),
      });
  }

  cancelPending(invite: ShareVehicleInviteResponse) {
    this.apiVehicleShareService
      .cancelInvite({ uid: this.uid, inviteId: invite.id })
      .subscribe({
        next: (res) => {
          if (res?.code === '000' || res?.success) {
            this.showSuccess(res.message || this.msg('ยกเลิกแล้ว', 'Cancelled'));
            if (this.selectedGroup) {
              this.loadPendingForVehicle(this.selectedGroup.vehicleId);
            }
          } else {
            this.showError(
              this.currentLanguage === 'TH'
                ? res?.message || 'ไม่สำเร็จ'
                : res?.message_en || 'Failed'
            );
          }
        },
        error: () => this.showError(this.msg('ไม่สำเร็จ', 'Failed')),
      });
  }

  askDissolve() {
    this.showConfirmDissolve = true;
  }

  confirmDissolve() {
    if (!this.selectedGroup) {
      return;
    }
    const groupId = this.selectedGroup.id;
    this.showConfirmDissolve = false;
    this.apiVehicleShareService.dissolveGroup({ uid: this.uid, groupId }).subscribe({
      next: (res) => {
        if (res?.code === '000' || res?.success) {
          this.showSuccess(res.message || this.msg('ยุบกลุ่มสำเร็จ', 'Dissolved'));
          this.closeManage();
          this.loadGroups();
        } else {
          this.showError(
            this.currentLanguage === 'TH'
              ? res?.message || 'ยุบไม่ได้'
              : res?.message_en || 'Cannot dissolve'
          );
        }
      },
      error: () => this.showError(this.msg('ยุบไม่ได้', 'Cannot dissolve')),
    });
  }

  leaveGroup(group: vehicleShareResponse) {
    this.apiVehicleShareService.leaveShare({ uid: this.uid, groupId: group.id }).subscribe({
      next: (res) => {
        if (res?.code === '000' || res?.success) {
          this.showSuccess(res.message || this.msg('ออกแล้ว', 'Left'));
          this.closeManage();
          this.loadGroups();
        } else {
          this.showError(
            this.currentLanguage === 'TH'
              ? res?.message || 'ไม่สำเร็จ'
              : res?.message_en || 'Failed'
          );
        }
      },
      error: () => this.showError(this.msg('ไม่สำเร็จ', 'Failed')),
    });
  }

  vehicleLabel(v: MyVehicleResponse): string {
    return v.name || `#${v.id}`;
  }

  vehicleIdOf(v: MyVehicleResponse): number {
    return v.id;
  }
}
